module.exports = __webpack_public_path__ + "img/16bc12a.png";